import { render, staticRenderFns } from "./PscsCli.vue?vue&type=template&id=ca042b44"
import script from "./PscsCli.vue?vue&type=script&lang=js"
export * from "./PscsCli.vue?vue&type=script&lang=js"
import style0 from "./PscsCli.vue?vue&type=style&index=0&id=ca042b44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports